import axios from "axios";
import AuthenticationLocalService from "../localStorage/AuthenticationLocalService";
import {URL_API_AUTH} from "./Utils";

/**
 * Checks credentials and authenticates user. Gets a token and stores it.
 * @author Alizée Grand
 * @version 1.0
 * @creation 11/01/2022
 * @last_update 11/01/2022
 **/
class AuthenticationDistantService {

    /**
     * Checks if an id exists and retrieves a token if necessary.
     * @param {string} id User identifier.
     * @returns {Promise<number>} Return the status of the request. Basically, 200 is ok.
     */
    async getToken(id: string): Promise<number> {
        let status = 500;
        await axios.post(URL_API_AUTH, {
            code_intervention: id,
            api_key: '61d86b12a6b8dac2d044720e'
        }).then((response) => {
            console.log(response);
            if(response.data.access_token) {
                AuthenticationLocalService.login(response.data.access_token.toString(), id);
            }
            status = response.status;
        }).catch((err) => {
            console.log("AUTHENTICATION ERROR " + err);
            status = err.response.status;
        });
        console.log(status);
        return status;
    }

}

export default new AuthenticationDistantService();
